import {useMutation, useQueryClient} from '@tanstack/react-query';

import {updateManagedMethod} from '../api';
import {QUERY__MANAGED_METHODS} from '../queryKeys';
import {ManagedMethod, ManagedMethodKind} from '../types';

// Takes the methods in the desired display order (first = shown first) and
// rewrites their `sort_order` to a dense descending sequence, patching only the
// rows whose value actually changes.
export const useReorderManagedMethods = (kind: ManagedMethodKind) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (orderedMethods: ManagedMethod[]) => {
      const total = orderedMethods.length;

      for (const [index, method] of orderedMethods.entries()) {
        const targetSortOrder = total - index;

        if (method.sortOrder !== targetSortOrder) {
          await updateManagedMethod({
            kind,
            id: method.id,
            sortOrder: targetSortOrder,
          });
        }
      }
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: [QUERY__MANAGED_METHODS, kind],
      });
    },
  });
};
